import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import DetailViewHeader from '#/shared/components/DetailViewHeader';
import GTM_HANDLES from '#/shared/gtm-handles';
import useCurrentLocation from '#/shared/hooks/useCurrentLocation';
import { setZoomToLocation } from '#/map/slice';
import * as Styled from './styled';

function LocationDetailHeader({
  location,
  navigateToTripPlannerTo,
  navigateToTripPlannerFrom,
}) {
  const { currentLocation } = useCurrentLocation();

  const dispatch = useDispatch();
  const zoomToLocation = () => {
    dispatch(setZoomToLocation(currentLocation));
  };

  return (
    <DetailViewHeader
      title={location.address}
      icon={<Styled.LocationIconSolid />}
      actions={
        <>
          <Styled.TripButton
            onClick={navigateToTripPlannerTo}
            dataGtm={GTM_HANDLES.location.locationDetailTripButtonGoHere}
          >
            <FormattedMessage id="detailview.gohere" />
          </Styled.TripButton>
          <Styled.TripButton
            onClick={navigateToTripPlannerFrom}
            dataGtm={GTM_HANDLES.location.locationDetailTripButtonStartHere}
          >
            <FormattedMessage id="detailview.starthere" />
          </Styled.TripButton>
          <Styled.ZoomToLocationButton
            onClick={zoomToLocation}
            dataGtm={GTM_HANDLES.location.locationDetailTripButtonStartHere}
          >
            <FormattedMessage id="nearbystops.location" />
          </Styled.ZoomToLocationButton>
        </>
      }
    />
  );
}

LocationDetailHeader.propTypes = {
  /** Location object that provides all info about a given location */
  location: PropTypes.shape({
    address: PropTypes.string,
  }).isRequired,
  /**
   * Function that triggers the action to navigate to the Trip Planner "To"
   * location
   */
  navigateToTripPlannerTo: PropTypes.func.isRequired,
  /**
   * Function that triggers the action to navigate to the Trip Planner "From"
   * location
   */
  navigateToTripPlannerFrom: PropTypes.func.isRequired,
};

export default LocationDetailHeader;
